import { gql } from "@apollo/client"

const GET_GROUP_BOOKING_MODAL_DATA = gql`
  query groupBookingStudentAvailability($input: GroupBookingStudentAvailabilityInput!, $page: Int!, $perPage: Int!) {
    groupBookingStudentAvailability(input: $input, page: $page, first: $perPage) {
      data {
        id
        forename
        surname

        guardians {
          id
          user_id
          salutation
          forename
          surname
          booking_id
          booked_slots {
            id
            starts_at
          }

          lessons {
            id
            name
          }

          meeting_type_id
        }
      }
      
      paginatorInfo {
          total
          totalBeforeFilters
          currentPage
          hasMorePages
          lastPage
          perPage
          __typename
        }
    }
  }
`

export { GET_GROUP_BOOKING_MODAL_DATA }